import CryptoJS from 'crypto-js';

export const encryptData = (data: any): any => {
    return CryptoJS.AES.encrypt(data, getSecretKey()).toString();
};

export const decryptData = (encryptedData: any) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, getSecretKey());
    return bytes.toString(CryptoJS.enc.Utf8);
};

export const getSecretKey = () => {
    return process.env.REACT_APP_SECRET_KEY ?? "";
};


export const readFromLocalStorage = (key: string) => {
    let encryptedData = localStorage.getItem(key) ?? "";
    if (encryptedData != "") {
        return decryptData(encryptedData);
    }
    return "";

}


export const writeToLocalStorage = (key: string, value: any) => {
    let data: any = "";
    if (value != "") {
        data = encryptData(value.toString());
    }
    localStorage.setItem(key, data);
    return;
}


